import {  types } from 'mobx-state-tree'



export const ImageFile = types
  .model({
    url: types.string,
    id_image_file: types.number,
  })